import { projectClient } from '../../client/client';

export const transactionalSMS = {
  send: projectClient('/messaging/transactional-sms/send').post,
};
